import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="sticky-footer fixed-bottom mb-2 ">
          <div className="container">
            <div className="text-center ml-5">
              <small>Copyright © CVAD-ONLINE 2020</small>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
